<script setup lang="ts">
import WarningModal from '../ui/reserve&reserve-flow/WarningModal.vue';
const emit = defineEmits<{
    close: [args: boolean];
}>();

const closeModal = () => emit('close', false);

onMounted(() => {
    addEventListener('click', closeModal, { once: true });
});
</script>
<template>
    <mr-simple-modal class="vpn-modal-layout">
        <WarningModal service="vpn" @close="emit('close', $event)" />
    </mr-simple-modal>
</template>
<style lang="scss" scoped>
.vpn-modal-layout {
    z-index: 2147483647;
}
</style>
